import { onResize, getWidth } from "../../utils/window";

export default function tidbitsDirective(context = document.body) {
	const $window = $(window);
	const _this = this;
	const $context = $(context);
	const $highlight = $context.find('[sw-highlight]');
	
	// const $element = $(this);
	// const prevMedia = $(this).closest('.body_column').prev().find('.media');
	// var mediaHeight = prevMedia.height();

	const setSize = function () {
		if(getWidth() > 1080) {
			$highlight.each(function() {
				const $element = $(this);
				const prevMedia = $(this).closest('.body_column').prev().find('.media');
				const mediaHeight = prevMedia.height();
				$element.height(mediaHeight + 'px');
			});
		}
	};

	// $highlight.each(function () {
	// 	mediaHeight = prevMedia.height();
	// 	$element.height(mediaHeight + 'px');
	// });

	setSize();

	onResize(() => {
		setSize();
	});
}



// WEBPACK FOOTER //
// ./source/scripts/directives/media/highlight.js